import React, { Component } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { debounce } from '../optimization'

class EditableLabel extends Component {
  constructor(props) {
    super(props)

    this.handleOnBlur = this.handleOnBlur.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.handleOnPaste = this.handleOnPaste.bind(this)
  }

  handleOnBlur(e) {
    this.props.handleLabelChange(this.props.labelKey, e.target.innerText)
  }

  handleOnClick() {
    this.props.handleLabelClick(this.props.labelKey)
  }

  handleOnPaste(e) {
    e.preventDefault()

    // get text representation of clipboard
    var text = e.clipboardData.getData('text/plain')

    // insert text manually
    document.execCommand('insertHTML', false, text)
  }

  shouldComponentUpdate(nextProps) {
    // for tinymce to work properly, component should not update if the editor is active
    if (this.props.editor === true) {
      return nextProps.editor !== true
    }
    return true
  }

  render() {
    const props = this.props
    let order = 0

    const extraProps = {}

    if (props.mode === 'builder') {
      extraProps.contentEditable = true
    }

    if (props.required === true) {
      extraProps.className = 'required'
    }

    if (props.handleLabelClick !== undefined) {
      extraProps.onClick = this.handleOnClick
    }

    if (props.editor === true) {
      extraProps.className += ' rteContainer'
      extraProps.contentEditable = false
      if (typeof props.labelKey === 'string') {
        order = props.order + '_' + props.labelKey
      } else {
        order = props.order
      }
      return (
        <div {...extraProps}>
          <Editor
            key={order}
            tinymceScriptSrc={'/tinymce/tinymce.min.js'}
            initialValue={props.value}
            init={{
              plugins: 'link image code',
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic | alignleft aligncenter ' +
                'alignright alignjustify | outdent indent removeformat image ',
              file_picker_types: 'image',
              automatic_uploads: true,
              images_file_types: 'jpg,svg,png,jpeg',
              images_upload_handler: props.rteUploadHandler,
              resize: false,
              promotion: false,
              paste_block_drop: true,
              paste_data_images: false
            }}
            onEditorChange={debounce((newValue) => {
              props.handleLabelChange(props.labelKey, newValue)
            }, 1500)}
          />
        </div>
      )
    }

    return props.value || props.mode === 'builder' ? (
      <div className={props.className}>
        <span
          onBlur={this.handleOnBlur}
          onPaste={this.handleOnPaste}
          dataplaceholder={props.dataPlaceholder}
          labelkey={props.labelKey}
          className={props.value === '' ? 'emptySpan' : null}
          {...extraProps}>
          {props.value ? props.value : ''}
        </span>
      </div>
    ) : (
      <></>
    )
  }
}

export default EditableLabel
